import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-lineup-th',
  templateUrl: './product-lineup-th.component.html',
  styleUrls: ['./product-lineup-th.component.css']
})
export class ProductLineupThComponent implements OnInit {


  constructor() { }
  mobile: boolean = false;
  ngOnInit(): void {
    if (window.screen.width < 640) { // 768px portrait
      this.mobile = true;

    }
    else {
      this.mobile = false;
    }

  }
  goToLink(url: string){
    window.open(url, "_blank");
}

}
